export const overallFilters = () => ({});

export const acquisitionFilters = ({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}) => {
  const filter = {
    filter: {
      filter_operator: 'and',
      filters: [
        {
          name: 'signed_up_date',
          operator: 'gte',
          value: startDate,
        },
        { name: 'signed_up_date', operator: 'lt', value: endDate },
      ],
    },
  };

  return filter;
};
export const activationFilters = ({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}) => {
  const filter = {
    filter: {
      filter_operator: 'and',
      filters: [
        {
          name: 'first_order_date',
          operator: 'gte',
          value: startDate,
        },
        {
          name: 'first_order_date',
          operator: 'lt',
          value: endDate,
        },
        {
          name: 'signed_up_date',
          operator: 'lt',
          value: startDate,
        },
      ],
    },
  };

  return filter;
};
export const retentionFilters = ({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}) => {
  const filter = {
    filter: {
      filter_operator: 'and',
      filters: [
        {
          name: 'first_order_date',
          operator: 'lt',
          value: startDate,
        },
      ],
    },
  };

  return filter;
};
export const churnFilters = ({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}) => {
  const filter = {
    filter: {
      filter_operator: 'and',
      filters: [{ name: 'signed_up_date', operator: 'lt', value: endDate }],
    },
  };

  return filter;
};

export const filters: Record<string, Function> = {
  overall: overallFilters,
  acquisition: acquisitionFilters,
  activation: activationFilters,
  retention: retentionFilters,
  churn: churnFilters,
};
